/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { getAPIConfig } from '@tcp/core/src/utils';
import config from '@tcp/core/src/components/common/organisms/ProductImages/config';
import { carousalStyle } from '@tcp/core/src/components/common/organisms/ProductImages/styles/ProductImages.style';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles, { ZoomPreventWrapper } from '../styles/FullSizeImageModal.style';
import Modal from '../../../../../../common/molecules/Modal';
import onDoubleTap, { imgConfigs, videoConfigs } from '../util';
import { getLocator, getVideoUrl } from '../../../../../../../utils';
import NonZoomableContainer from '../../NonZoomableContainer/views/NonZoomableContainer';

class FullSizeImageModal extends React.Component {
  handleTouchStart = onDoubleTap(() => {
    const { isZoomIn } = this.state;
    this.setState({ isZoomIn: !isZoomIn });
  });

  static propTypes = {
    /** Current image's name or title to product's figure */
    name: PropTypes.string,

    /** Current image's path to main product's figure.  */
    image: PropTypes.string.isRequired,

    /** function to call to close this modal */
    onCloseClick: PropTypes.func.isRequired,
    isZoomIn: PropTypes.bool,
    className: PropTypes.string,
    modalLabel: PropTypes.string,
    customOverlayClass: PropTypes.string,
    selectedPDPImage: PropTypes.string,
    isPDP: PropTypes.bool,
    fromQv: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { isZoomIn, selectedPDPImage } = this.props;
    this.selectedPDPImageURL = '';
    this.shouldShowSelectedPDPImage = !!selectedPDPImage;
    this.scrollRef = React.createRef();
    this.nonZoomContainerRef = React.createRef();
    this.state = {
      isZoomIn: !!isZoomIn,
      currentImageIndex: 0,
      imgDataState: {
        alt: '',
        url: '',
      },
    };
  }

  getImage = (url) => {
    let selectedPDPImageURLData = {};
    if (!this.selectedPDPImageURL) {
      const clickedAltImagePath = url;
      this.selectedPDPImageURL = url;
      const { images } = this.props;
      const pathSplitArray = clickedAltImagePath?.split('/');
      const pathSplitArrayLength = pathSplitArray?.length;
      const firstpart = pathSplitArray[pathSplitArrayLength - 2];
      const secondpart = pathSplitArray[pathSplitArrayLength - 1];
      const finalImageUrl = `${firstpart}/${secondpart}`;
      const selectedImageIndex = this.getDefaultImageIndex(finalImageUrl, images);
      selectedPDPImageURLData = {
        alt: 'Alt Image',
        url: finalImageUrl,
        selectedImageIndex,
      };
      this.setState({
        currentImageIndex: selectedImageIndex,
        imgDataState: selectedPDPImageURLData,
      });
      return selectedPDPImageURLData;
    }
    return selectedPDPImageURLData;
  };

  handleImageChange = (event, nextImage) => {
    let pathSplitArrayLength;
    let firstpart;
    let secondpart;
    let finalImageUrl;
    this.shouldShowSelectedPDPImage = false;
    if (nextImage || parseInt(nextImage, 10) === 0) {
      this.setState({
        imgDataState: {
          selectedImageIndex: nextImage,
        },
      });
    } else {
      const clickedAltImagePath = event?.target?.currentSrc;
      const selectedImageIndex = event?.target?.id;
      const pathSplitArray = clickedAltImagePath?.split('/');
      if (pathSplitArray) {
        pathSplitArrayLength = pathSplitArray?.length;
        firstpart = pathSplitArray[pathSplitArrayLength - 2];
        secondpart = pathSplitArray[pathSplitArrayLength - 1];
        finalImageUrl = `${firstpart}/${secondpart}`;
        this.setState({
          currentImageIndex: selectedImageIndex,
          imgDataState: {
            alt: 'Alt Image',
            url: finalImageUrl,
            selectedImageIndex,
          },
        });
      }
    }
  };

  getDefaultImageIndex = (defaultImage, images) => {
    for (let i = 0; i < images?.length; i += 1) {
      if (images && images[i].iconSizeImageUrl === defaultImage) {
        return i;
      }
    }

    return null;
  };

  renderImageDotes = () => {
    const { images } = this.props;

    const { currentImageIndex } = this.state;
    const activeImageIndex = parseInt(currentImageIndex, 10);
    return (
      <div className="new-image-dots-wrapper">
        <ul>
          {images &&
            images.map((_, index) => {
              return (
                <li
                  className={`pdp-dots ${index === activeImageIndex ? 'image-active' : ''}`}
                  key={`pdp-dots_${index.toString()}`}
                >
                  <div
                    key={index.toString()}
                    className={` ${index === activeImageIndex ? 'pdp-image-active' : null}`}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    );
  };

  getAltImageChipsOptionsMap = () => {
    const { images, primaryBrand, alternateBrand } = this.props;
    const apiConfig = getAPIConfig();
    let { brandId } = apiConfig;
    brandId = primaryBrand || alternateBrand || brandId;
    const assetPrefix = apiConfig[`productAssetPath${brandId?.toUpperCase()}`];
    const assetHost = apiConfig[`assetHost${brandId?.toUpperCase()}`];
    const imgConfig = 't_pdp_imgswatch,f_auto,q_auto';
    const { currentImageIndex } = this.state;
    const activeImageIndex = parseInt(currentImageIndex, 10);

    return (
      images &&
      images.map((item, colorIndex) => {
        const imgUrl = item.iconSizeImageUrl;
        return (
          <span
            className={`${
              activeImageIndex === colorIndex ? 'color-title-container-selected' : ''
            } color-title-container`}
          >
            <img
              src={`${assetHost}/${imgConfig}/${assetPrefix}/${imgUrl}`}
              className="color-image"
              onClick={this.handleImageChange}
              id={colorIndex}
              onKeyDown={this.handleImageChange}
              alt="altImage"
              isProductImage
            />
          </span>
        );
      })
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const {
      onCloseClick,
      className,
      name,
      modalLabel,
      primaryBrand,
      alternateBrand,
      images,
      isPinchZoomPDPImageEnabled,
      customOverlayClass,
      selectedPDPImage,
      isPDP,
      fromQv,
    } = this.props;
    const { currentImageIndex } = this.state;
    const { CAROUSEL_OPTIONS_ALT_IMAGES } = config;
    const getImageCurrent = selectedPDPImage && this.getImage(selectedPDPImage);
    if (this.shouldShowSelectedPDPImage)
      CAROUSEL_OPTIONS_ALT_IMAGES.initialSlide = currentImageIndex;
    CAROUSEL_OPTIONS_ALT_IMAGES.beforeChange = (current, next) => {
      this.handleImageChange(null, next);
      this.setState({ currentImageIndex: next });
    };

    return (
      <Modal
        isOpen
        onRequestClose={onCloseClick}
        overlayClassName="TCPModal__Overlay"
        className={`${className} TCPModal__Content`}
        dataLocator={getLocator('pdp_full_size_image_modal')}
        closeIconDataLocator={getLocator('pdp_zoomed_image_closed_btn')}
        fixedWidth
        contentLabel={`${name} ${modalLabel}`}
      >
        <div className="overlay-content">
          <div ref={this.scrollRef} className={`${customOverlayClass}`}>
            <Carousel
              options={config.CAROUSEL_OPTIONS_ALT_IMAGES}
              inheritedStyles={carousalStyle}
              carouselConfig={{
                autoplay: false,
                dots: false,
              }}
              className="product-img-slider"
            >
              {images
                ? images.map((item, zoomImageIndex) => {
                    const isVideoUrl = getVideoUrl(item.url);
                    const mainConfig = isVideoUrl ? videoConfigs : imgConfigs;
                    const imgUrl = item.iconSizeImageUrl;
                    const { isZoomIn, imgDataState } = this.state;
                    let imgData = {
                      alt: name,
                      url: imgUrl,
                    };
                    if (imgDataState && imgDataState.url) {
                      imgData = {
                        alt: 'alt image',
                        url: imgDataState.url,
                      };
                    }
                    if (
                      this.shouldShowSelectedPDPImage &&
                      getImageCurrent &&
                      getImageCurrent?.url &&
                      !imgDataState.url
                    ) {
                      imgData = {
                        alt: getImageCurrent?.alt,
                        url: getImageCurrent.url,
                      };
                    }
                    const classNames = isPinchZoomPDPImageEnabled
                      ? className
                      : [className, 'image-zoom', isZoomIn ? 'active-zoom-in' : ''].join(' ');

                    return (
                      <div
                        className="product-image-wrapper"
                        id={zoomImageIndex}
                        ref={this.scrollRef}
                        key={`${zoomImageIndex}`}
                      >
                        <figure
                          className={classNames}
                          onTouchStart={this.handleTouchStart}
                          onClickItem={this.handleImageChange}
                          onChange={this.handleImageChange}
                          onSwipe={this.handleImageChange}
                        >
                          <DamImage
                            imgData={imgData}
                            isProductImage
                            imgConfigs={mainConfig}
                            primaryBrand={primaryBrand || alternateBrand}
                            id={zoomImageIndex}
                            isPinchZoomImage={isPinchZoomPDPImageEnabled}
                            selectedPDPImage={
                              this.shouldShowSelectedPDPImage ? selectedPDPImage : ''
                            }
                            isPDP={isPDP}
                            fromQv={fromQv}
                          />
                        </figure>
                        {this.renderImageDotes}
                      </div>
                    );
                  })
                : null}
            </Carousel>
          </div>
        </div>
        <NonZoomableContainer>
          <div className="color-selector" ref={this.nonZoomContainerRef}>
            {this.renderImageDotes()}
            <div className="image-chips-selector-container image-chips-selector">
              <div className="image-chips-selector-items-list">
                {this.getAltImageChipsOptionsMap()}
              </div>
            </div>
          </div>
        </NonZoomableContainer>
        <NonZoomableContainer>
          <ZoomPreventWrapper />
        </NonZoomableContainer>
      </Modal>
    );
  }
}

FullSizeImageModal.defaultProps = {
  name: '',
  isZoomIn: false,
  className: '',
  modalLabel: '',
  customOverlayClass: '',
  selectedPDPImage: '',
  isPDP: false,
  fromQv: false,
};

export default withStyles(FullSizeImageModal, styles);
export { FullSizeImageModal as FullSizeImageModalVanilla };
